import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "../components/common/LoadingSpinner";
import ConnectionBanner from "../components/common/ConnectionBanner";
import { clearCache } from "../utils/cache";

const PIN_LENGTH = 4;
const DOTS = Array.from({ length: PIN_LENGTH });

export default function LoginPage() {
  const [nik, setNik]     = useState("");
  const [pin, setPin]     = useState("");
  const { login, loading, error, setError } = useAuth();
  const navigate = useNavigate();
  // const pinInputRef = useRef(null);

  useEffect(() => {
    setPin("");
  }, []);
  
  const handlePinKey = (val) => {
    if (loading) return; // Jangan izinkan input kalau lagi loading
    if (pin.length < PIN_LENGTH) {
      setPin(prev => prev + val);
    }
  };

  const handleDelete = () => setPin((p) => p.slice(0, -1));

  const handleSubmit = async () => {
    if (loading) return;


    if (!nik.trim()) { setError("NIK tidak boleh kosong"); return; }
    if (pin.length < PIN_LENGTH) { setError("Masukkan 4 digit PIN"); return; }

    const ok = await login(nik.trim(), pin);

    if (ok) {
      clearCache(); // clear semua cache user sebelumnya
      navigate("/dashboard");
    }
    else{
      setPin("");
    }
  };
  

  const keys = ["1","2","3","4","5","6","7","8","9","","0","⌫"];

  return (
    <div className="login-screen h-dvh bg-gradient-to-b from-primary to-primary-dark flex flex-col overflow-hidden">
      <ConnectionBanner />
      {/* Top branding */}
      <div className="login-brand flex flex-col items-center pt-8 pb-5 px-6 shrink-0">
        <div className="login-logo w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center mb-3 shadow-lg">
          <svg className="login-logo-icon" width="32" height="32" viewBox="0 0 24 24" fill="white">
            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
          </svg>
        </div>
        <h1 className="text-white text-xl font-bold font-display leading-tight">Redcrest HR</h1>
        <p className="login-subtitle text-white/70 text-xs mt-0.5">Employee Self-Service</p>
      </div>

      {/* Card */}
      <div className="login-card flex-1 min-h-0 bg-white rounded-t-3xl px-6 pt-5 pb-4 flex flex-col animate-fade-up">
        {/* NIK */}
        <label className="text-xs text-gray-500 font-semibold uppercase tracking-wide mb-1.5">
          Employee ID (NIK)
        </label>
        <input
          value={nik}
          onChange={(e) => { setNik(e.target.value); setError(null); }}
          placeholder="e.g., RC-42815"
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm font-medium
            focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary mb-4 bg-gray-50"
        />

        {/* PIN label */}
        <label className="text-xs text-gray-500 font-semibold uppercase tracking-wide mb-2.5">
          4-digit PIN
        </label>

        {/* PIN dots */}
        <div className="flex justify-center gap-4 mb-1">
          {DOTS.map((_, i) => (
            <div
              key={i}
              className={`w-12 h-12 rounded-xl border-2 flex items-center justify-center transition-all
                ${i < pin.length
                  ? "bg-primary border-primary"
                  : "bg-gray-50 border-gray-200"}`}
            >
              {i < pin.length && <div className="w-3 h-3 rounded-full bg-white" />}
            </div>
          ))}
        </div>

        {/* Error */}
        <div className="min-h-5 mb-1 flex items-center justify-center">
          {error && (
            <p className="text-red-600 text-sm text-center font-medium animate-fade-in">
              {error}
            </p>
          )}
        </div>

        {/* Keypad */}
        <div className="grid grid-cols-3 gap-3 mt-3 mb-5">
          {keys.map((k, i) => (
            <button
              key={i}
              disabled={k === ""}
              onClick={() => k === "⌫" ? handleDelete() : k !== "" && handlePinKey(k)}
              className={`h-14 rounded-2xl text-lg font-semibold transition-all active:scale-95
                ${k === ""    ? "invisible" : ""}
                ${k === "⌫"  ? "bg-gray-100 text-gray-600 hover:bg-gray-200" : "bg-gray-50 text-gray-800 hover:bg-gray-100 border border-gray-100"}
              `}
            >
              {k}
            </button>
          ))}
        </div>

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="w-full bg-primary hover:bg-primary-dark text-white font-bold py-4 rounded-2xl
            transition-all active:scale-[0.98] disabled:opacity-60 flex items-center justify-center gap-2
            shadow-lg shadow-primary/30 font-display"
        >
          {loading ? <LoadingSpinner size={20} color="white" /> : null}
          {loading ? "Memverifikasi..." : "Masuk"}
        </button>

        <p className="login-help text-center text-xs text-gray-400 mt-3">
          Tidak perlu email — masuk dengan NIK & PIN kamu
        </p>
      </div>
    </div>
  );
}
